module.exports = __webpack_public_path__ + "static/img/SouthPressCoffee@2x.5d8fef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/SouthPressCoffee@2x.png
// module id = 5lBB
// module chunks = 0